import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

const CLASS_NAME = 'bv-text';

enum VARIATIONS {
  Positive = 'positive',
  Negative = 'negative',
  Strong = 'strong',
  Subdued = 'subdued',
  Code = 'code'
}

function variationTagName(variation?: VARIATIONS) {
  switch (variation) {
    case VARIATIONS.Code:
      return 'code';
    case VARIATIONS.Strong:
      return 'b';
    case VARIATIONS.Positive:
    case VARIATIONS.Negative:
    case VARIATIONS.Subdued:
    default:
      return 'span';
  }
}

function variationClass(variation: VARIATIONS) {
  if (Object.values(VARIATIONS).includes(variation)) {
    return `${CLASS_NAME}--${variation}`;
  }
  return '';
}

interface IArgs {
  variation: VARIATIONS;
  text: string;
}

export default class BvText extends Component<IArgs> {
  @tracked elementName: 'code' | 'b' | 'span' = 'span';

  constructor(owner: any, args: IArgs) {
    super(owner, args);
    this.elementName = variationTagName(this.args.variation);
  }

  get variationClass() {
    return variationClass(this.args.variation);
  }
}
